const subscriptions = {};
const getNextUniqueId = getIdGenerator();

function subscribe(eventType, callback) {
  const id = getNextUniqueId();

  if (!subscriptions[eventType]) subscriptions[eventType] = {};

  subscriptions[eventType][id] = callback;

  return {
    unsubscribe: () => {
      delete subscriptions[eventType][id];
      if (Object.keys(subscriptions[eventType]).length === 0) delete subscriptions[eventType];
    },
  };
}

function publish(eventType, arg) {
  if (!subscriptions[eventType]) {
    return;
  } else {
    const events = Object.keys(subscriptions[eventType]);
    if (events.length < 0) return;
    events.forEach((key) => (typeof subscriptions[eventType][key] === 'function' ? subscriptions[eventType][key](arg) : () => {}));
  }
}

function getIdGenerator() {
  let lastId = 0;

  return function getNextUniqueId() {
    lastId += 1;
    return lastId;
  };
}

const EventBus = { publish, subscribe };
export default EventBus;
